<script lang="ts">
	// Stores
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { devices } from 'src/stores/lists/devices';

	// Design System Components
	import { SidepanelContent } from '@Shelly/shelly-design-system';

	// Components
	import SchedulesG2 from 'src/components/DevicesSettings/Schedules/SchedulesG2/SchedulesG2.svelte';
	import SchedulesG1 from 'src/components/DevicesSettings/Schedules/SchedulesG1/SchedulesG1.svelte';

	// Helpers
	import { is_gen_2 } from 'src/helpers/interface_helpers';

	// Types
	import type { Device } from 'src/types/Device.ts';

	// Get device data from sidepanel state
	let id = $sidePanelStateCombined?.id;
	export let device: Device = $devices[id];
	$: isGen2 = device ? is_gen_2(device) : false;

	// testing... not sure if we need this abstraction here.
</script>

<SidepanelContent>
	{#if device}
		{#if isGen2}
			<SchedulesG2 {device} />
		{:else}
			<SchedulesG1 {device} />
		{/if}
	{:else}
		<div class="loading-state">
			<div class="flex-full-height"></div>
		</div>
	{/if}
</SidepanelContent>
